<template>
  <div>
    <div>
      <a @click="openSort">
        <i class="icon-filter" />
      </a>
    </div>
  </div>
</template>

<script setup>
import useModalStore from '@global/stores/useModalStore';

const modalStore = useModalStore();
const { openModal } = modalStore;

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

function openSort() {
  openModal('SortPopup', props.data);
}
</script>

<style></style>
